import { Outlet } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { CONTACT } from "@/components/ContactCards";

export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-[#030F26]">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <a
        data-testid="floating-whatsapp-button"
        href={CONTACT.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full border border-[#C5A059]/60 bg-[#071838]/90 text-[#C5A059] shadow-[0_8px_32px_rgba(3,15,38,0.6)] backdrop-blur-xl transition-all duration-300 hover:scale-110 hover:bg-[#C5A059] hover:text-[#030F26]"
      >
        <MessageSquare className="h-5 w-5" />
      </a>
    </div>
  );
}
